module.exports = __webpack_public_path__ + "img/pay-succes.155d2a8b.png";